import * as fromLogger from "./logger";

export const logger = fromLogger;
